<template>
  <div class="basic-file-input-container">
    <label
      :for="name"
      class="input-file btn-custom"
    >{{ placeholder }} <img
      src="@/assets/icons/upload-file.svg"
      alt="upload file"
    ></label>
    <Field
      v-slot="{ field }"
      :label="label"
      :name="name"
      :rules="validation"
    >
      <input
        :id="name"
        v-bind="field"
        :ref="name"
        type="file"
        @change="onInput($event)"
      >
      <ErrorMessage
        class="error-msg"
        :name="name"
      />
    </Field>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/**
 *
 */
export default {
  name: 'BasicFileInput',
  components: { Field, ErrorMessage },
  props: {
    label: String,
    placeholder: String,
    validation: [String, Boolean],
    name: String
  },
  emits: ['addData'],
  data() {
    return {
      file: null
    }
  },
  mounted() {
    this.mutatedValue
      ? this.$emit('addData', { value: this.mutatedValue, name: this.name })
      : this.$emit('addData', { value: '', name: this.name })
  },
  methods: {
    onInput(event) {
      this.file = event.target.files[0]
      this.$emit('addData', { value: this.file, name: this.name })
    }
  }
}
</script>

<style lang="scss" scoped>
  .basic-file-input-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;

    /* Tablet (portrait) */
    @media only screen and (width >= 768px) {
      margin: 20px 0;
    }

    /* Desktops and laptops */
    @media only screen and (width >= 1024px) {
      margin: 20px 0;
    }

    /* Large screens */
    @media only screen and (width >= 1824px) {
      margin: 20px 0;
    }

    input[type='file'] {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
    }

    label.input-file.btn-custom img {
      padding-left: 10px;
      transform: scale(0.8);
    }
  }
</style>
